var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraftFill = function SvgDraftFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.2 3a.9.9 0 0 1 .9.9v3.381l-8.1 8.1-.005 3.814 3.822.006 4.283-4.283V20.1a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9zm1.6 6.127 1.273 1.273-7 7-1.275-.002.002-1.27zM12 12H7.5v1.8H12zm2.7-3.6H7.5v1.8h7.2z"
  })));
};
export default SvgDraftFill;